"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoService = void 0;
var hmac_sha1_1 = __importDefault(require("crypto-js/hmac-sha1"));
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
/**
 * The CryptoService is used for encrypting objects and strings similar to the cryptojs NPM package.
 */
var CryptoService = /** @class */ (function () {
    function CryptoService() {
        this.browserSupportsCrypto = false;
        if (window.crypto && window.TextEncoder) {
            this.encoder = new window.TextEncoder('utf-8');
            this.browserSupportsCrypto = true;
        }
    }
    CryptoService.prototype.base64HmacSHA1 = function (data, secret) {
        if (secret === void 0) { secret = 'none'; }
        if (!this.browserSupportsCrypto) {
            return '';
        }
        var signature = (0, hmac_sha1_1.default)(data, secret);
        var asStr = enc_base64_1.default.stringify(signature);
        return asStr;
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It work on https, but it's not work on http
     * Try base64HmacSHA1
     *
     */
    CryptoService.prototype.getCrypto = function () {
        return window.crypto || window.msCrypto;
    };
    CryptoService.prototype.getCryptoSubtle = function () {
        var crypto = this.getCrypto();
        return (crypto === null || crypto === void 0 ? void 0 : crypto.subtle) || crypto.webkitSubtle;
    };
    CryptoService.prototype.createRandomString = function () {
        var crypto = this.getCrypto();
        var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.';
        var random = '';
        var randomValues = Array.from(crypto.getRandomValues(new Uint8Array(43)));
        randomValues.forEach(function (v) { return (random += charset[v % charset.length]); });
        return random;
    };
    CryptoService.prototype.sha256 = function (string) {
        return __awaiter(this, void 0, void 0, function () {
            var digestOp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        digestOp = this.getCryptoSubtle().digest({ name: 'SHA-256' }, new TextEncoder().encode(string));
                        // IE11 support since IE11 uses a digest operation that doesn't return a promise
                        if (window.msCrypto) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    digestOp.oncomplete = function (e) {
                                        resolve(e.target.result);
                                    };
                                    digestOp.onerror = function (e) {
                                        reject(e.error);
                                    };
                                    digestOp.onabort = function () {
                                        reject('Crypto digest was aborted');
                                    };
                                })];
                        }
                        return [4 /*yield*/, digestOp];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    /**
     * Encrypts the given data using SHA-1
     * @param data
     * @param secret
     * @returns
     */
    CryptoService.prototype.hmacSha1 = function (data, secret) {
        if (secret === void 0) { secret = 'none'; }
        return __awaiter(this, void 0, void 0, function () {
            var key, signature, uint8Array, asStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.browserSupportsCrypto) {
                            return [2 /*return*/, ''];
                        }
                        return [4 /*yield*/, this.getKey('SHA-1', secret)];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, this.sign(key, 'HMAC', data)];
                    case 2:
                        signature = _a.sent();
                        uint8Array = new Uint8Array(signature);
                        asStr = this.bytesToString(uint8Array);
                        return [2 /*return*/, asStr];
                }
            });
        });
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It work on https, but it's not work on http
     * Try create a new use crypto-js, it not used before
     *
     */
    CryptoService.prototype.hmacSha265 = function (data, secret) {
        if (secret === void 0) { secret = 'none'; }
        return __awaiter(this, void 0, void 0, function () {
            var key, signature, uint8Array, asStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.browserSupportsCrypto) {
                            return [2 /*return*/, ''];
                        }
                        return [4 /*yield*/, this.getKey('SHA-256', secret)];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, this.sign(key, 'HMAC', data)];
                    case 2:
                        signature = _a.sent();
                        uint8Array = new Uint8Array(signature);
                        asStr = this.bytesToString(uint8Array);
                        return [2 /*return*/, asStr];
                }
            });
        });
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It work on https, but it's not work on http
     * Try create a new use crypto-js
     *
     */
    CryptoService.prototype.getKey = function (hashName, secret) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, crypto.subtle.importKey('raw', 
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.encoder.encode(secret), {
                            name: 'HMAC',
                            hash: {
                                name: hashName,
                            },
                        }, false, ['sign', 'verify'])];
                    case 1:
                        key = _a.sent();
                        return [2 /*return*/, key];
                }
            });
        });
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It work on https, but it's not work on http
     * Try create a new use crypto-js
     *
     */
    CryptoService.prototype.sign = function (key, algorithmName, data) {
        return __awaiter(this, void 0, void 0, function () {
            var signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, crypto.subtle.sign({ name: algorithmName }, key, 
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.encoder.encode(data))];
                    case 1:
                        signature = _a.sent();
                        return [2 /*return*/, signature];
                }
            });
        });
    };
    CryptoService.prototype.bytesToString = function (n) {
        var i = [];
        // tslint:disable-next-line:prefer-for-of
        for (var t = 0; t < n.length; t++) {
            i.push(String.fromCharCode(n[t]));
        }
        return i.join('');
    };
    CryptoService = __decorate([
        (0, CommonService_decorator_1.CommonService)('CryptoService'),
        __metadata("design:paramtypes", [])
    ], CryptoService);
    return CryptoService;
}());
exports.CryptoService = CryptoService;
//# sourceMappingURL=Crypto.service.js.map